export function extractProperty(property: any): string {
  if (property === 0) {
    return '0';
  }
  return !!property ? `${property}` : '';
}

export function extractBooleanProperty(property: any): string {
  return !!property ? '⎷' : '-';
}
